import classnames from "classnames";
import React, { Component } from "react";
import { Circle, Disc, X } from "react-feather";
import logoDorado from "../../../../assets/images/isotipo-dorado.png";

/**
 * SidebarHeader component represents the header section of the sidebar in the application.
 * It includes the branding text, toggle icons for collapsing/expanding the sidebar, and a shadow effect.
 * This component receives props like toggleSidebarMenu, activeTheme, collapsed, toggle, sidebarVisibility, and menuShadow.
 * It renders different icons based on the state of the sidebar (collapsed or expanded) and the active theme.
 */
class SidebarHeader extends Component {
  render() {
    let {
      toggleSidebarMenu,
      collapsed,
      toggle,
      sidebarVisibility,
      menuShadow,
    } = this.props;
    return (
      <div className="navbar-header">
        <ul className="nav navbar-nav flex-row align-items-center">
          <li className="nav-item mr-auto">
            <div className="navbar-brand d-flex align-items-center">
              <img
                src={logoDorado}
                alt="Turnero"
                className="brand-logo mr-2 ml-3"
              />
              <div className="brand-text text-info mr-5">Turnero</div>
            </div>
          </li>
          <li className="nav-item nav-toggle">
            <div className="nav-link modern-nav-toggle">
              {collapsed === false ? (
                <Disc
                  onClick={() => {
                    toggleSidebarMenu(true);
                    toggle();
                  }}
                  className="toggle-icon icon-x d-none d-xl-block font-medium-4 text-white"
                  size={20}
                  data-tour="toggle-icon"
                />
              ) : (
                <Circle
                  onClick={() => {
                    toggleSidebarMenu(false);
                    toggle();
                  }}
                  className="toggle-icon icon-x d-none d-xl-block font-medium-4 text-white"
                  size={20}
                />
              )}
              <X
                onClick={sidebarVisibility}
                className="toggle-icon icon-x d-block d-xl-none font-medium-4 float-right text-white"
                size={20}
              />
            </div>
          </li>
        </ul>
        <div
          className={classnames("shadow-bottom", {
            "d-none": menuShadow === false,
          })}
        />
      </div>
    );
  }
}

export default SidebarHeader;
